export default "__VITE_ASSET__D9tJcIZ3__"